import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="email-address-confirmation"
export default class extends Controller {
  static targets = ["email"]

  confirm(event) {
    const message = `Change this user's email address to ${this.emailTarget.value}?`

    if (window.confirm(message)) return

    event.preventDefault()
    event.stopImmediatePropagation()
  }
}
